import { GET_MEMBERSHIPS_DATA, GET_MEMBERSHIPS_DATA_SUCCESS, GET_MEMBERSHIPS_DATA_ERROR, GET_MEMBERSHIPS_DATA_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetMembershipsData = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEMBERSHIPS_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIPS_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_MEMBERSHIPS_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_MEMBERSHIPS_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetMembershipsData;
